import './navbar.scss';
import $ from 'jquery';

$(document).ready(function () {
  var win = $(window);
  var header = $('header');
  var scrollDelayedHandler = null;
  var lastScrollTop = 0;

  $(window).on('scroll', function () {
    if (scrollDelayedHandler) {
      return;
    }

    scrollDelayedHandler = setTimeout(function () {
      scrollDelayedHandler = null;
      var scrollTop = win.scrollTop();
      if (win.outerWidth() >= 1024) {
        scrollTop = scrollTop - header.height() + 90;
      }
      if (Math.abs(lastScrollTop - scrollTop) > 5) {
        lastScrollTop = scrollTop;
        if (scrollTop > 30) {
          header.addClass('sticky-shrinked');
        } else {
          header.removeClass('sticky-shrinked');
        }
      }
    }, 500);
  });
});



// WEBPACK FOOTER //
// ./src/components/navbar/navbar.js